export class Constants {
}
Constants.HEART_BEAT_INTERVAL = 30000;
Constants.WATCH_TIMEOUT = 5000;
Constants.CACHE_MODULE = 'configure-module';
Constants.CENTRAL_AUTH_REDIRECT_URL = 'https://spaces.qa-dnaspaces.io/ca/?src=sws';
Constants.EVENTS = {
    READ: {
        STATUS: 'status',
        INIT: 'init',
        SHOW_FRAME: 'showFrame',
        SET_TOKEN: 'setToken',
        ACTIVATE_DEVICE: 'activateDevice',
        REFRESH: 'refresh',
    },
    WRITE: {
        INIT: 'init',
        FETCH_URL: 'fetchUrl',
        HEARTBEAT: 'heartbeat',
        REFRESH_TOKEN: 'refreshToken',
    },
    INTERNAL: {
        SHOW_FRAME: 'showFrame',
        SET_TOKEN: 'setToken',
    },
};
Constants.PAGES = {
    LOADER: '/loader',
    CONFIGURE: '/configure',
    DISPLAY_CODE: '/displayCode',
    SHOW_FRAME: '/showFrame',
    DELETE: '/delete',
};
Constants.IFRAME_MESSAGE_TYPE = {
    GET_TOKEN: 'getToken@dnas-sw',
    SET_TOKEN: 'setToken@dnas-sw',
};
Constants.CACHE = {
    DEVICE_TYPE: '/t/deviceType',
    DEVICE_NAME: 'deviceName',
    ACTIVATED: '/t/activated',
    REGISTERD: '/t/registered',
    TOKEN: 'token',
    RMS_TOKEN: 'rms_token',
    FRAME_URL: '/t/frameUrl',
    ORG_ID: '/t/orgId',
    DEVICE_ID: '/t/deviceId',
    IS_NAVIGATOR: 'isNavigator',
    NAVIGATOR_PARAMS_EXTRACT: 'navigatorParamsExtract',
    CODE: 'code',
    TENANT_ID_MASKED: '/t/tenantIdMasked',
    UID: '/t/uid',
    DOMAIN: 'domain',
    EVENT_MESSAGE_TIME: 'eventMessageTime',
    APP_URL: 'appUrl',
    NATS_JWT_TOKEN: 'nats_jwt_token',
    NATS_REFRESH_TOKEN: 'nats_refresh_token',
    CAUTH_TOKEN: 'cauth_token',
    TENANT_ID: 'tenant_id',
};
Constants.DEVICE = {
    WEBEX: 'webex',
    NON_WEBEX: 'non-webex',
    NAVIGATOR: 'navigator',
};
Constants.ALERTS = {
    SIGNAGE_2_1_SUCCESS: {
        name: '[SIGNAGE_2_1_SUCCESS]',
        severity: 'fatal',
    },
    JETSTREAMS_CONNECT_FAIL: {
        name: '[JETSTREAMS_CONNECT_FAIL]',
        severity: 'fatal',
    },
    JETSTREAMS_DIRECT_GET_FAIL: {
        name: '[JETSTREAMS_DIRECT_GET_FAIL]',
        severity: 'low',
    },
    JETSTREAMS_SUBSCRIPTION_FAIL: {
        name: '[JETSTREAMS_SUBSCRIPTION_FAIL]',
        severity: 'fatal',
    },
    JETSTREAMS_PUBLISH_FAIL: {
        name: '[JETSTREAMS_PUBLISH_FAIL]',
        severity: 'fatal',
    },
    JETSTREAMS_ERROR: { name: '[JETSTREAMS_ERROR]', severity: 'low' },
    CLIENT_ERROR: { name: '[CLIENT_ERROR]', severity: 'low' },
    INIT_DISCONNECT: { name: '[INIT_DISCONNECT]', severity: 'low' },
    UNKNOWN_ERROR: { name: '[UNKNOWN_ERROR]', severity: 'low' },
    RICHMAPS_ERROR: { name: '[RICHMAPS_ERROR]', severity: 'fatal' },
    CONTEXT_API_FAIL: { name: '[CONTEXT_API_FAIL]', severity: 'fatal' },
    REGISTER_API_FAIL: { name: '[REGISTER_API_FAIL]', severity: 'fatal' },
};
